<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2BVE8h/tc-custom/9781634867290.jpg?1723405853955" alt="This image is the cover for the book Safe Harbor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Safe Harbor
      </h1>
      <p class="bookDescription body article font2">
        <p>Best friends since they were children, Mikhail and Solomon later took their friendship to the next level. But they have a falling out after a horrible mistake.<br/><br/>Seven years later, the men are reunited on a cruise ship in the Mediterranean where they both work as waiters. The animosity between them runs deep, but the close quarters at sea bring them back together, with a little help from a fellow shipmate.<br/><br/>Can Solomon and Mikhail move beyond the mistakes they made in the past and rekindle what they had? Or are they fated to only being friends?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David O. Sullivan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?326f4f42